import { oz } from '@weft/utils';
import { BillingIntervalSchema, ErpMetadataSchema, PaymentTermSchema } from '../../primitives';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { NewCommitmentSchema } from '../commitment';
import { NewProductVariantSchema } from '../product-variant';

export const NewProductSchema = oz.object({
  name: withNullAsOptional(oz.string().nonempty()),
  description: withNullAsOptional(oz.string()),
  variants: oz.array(NewProductVariantSchema).min(1),
  basePrice: withNullAsOptional(oz.number().nonnegative()),
  commitment: withNullAsOptional(NewCommitmentSchema),
  currencyCommitment: withNullAsOptional(oz.number()),
  paymentTerm: PaymentTermSchema,
  billingInterval: BillingIntervalSchema,
  proRata: withNullAsOptional(oz.boolean()),
  erpMetadata: withNullAsOptional(ErpMetadataSchema),
  rateMultiplier: withNullAsOptional(oz.number()),
  isPeriodicConsumption: withNullAsOptional(oz.boolean()),
  isPeriodicVariants: oz.boolean().optional().default(false),
}).openapi('NewProduct');

export type NewProduct = oz.infer<typeof NewProductSchema>;